export const OCPP_MESSAGES_1_6 = {
  Authorize: 1001,
  BootNotification: 1002,
  ChangeConfiguration: 1014,
  ChargeLevelChange: 2028,
  ClearCache: 1025,
  ClearChargingProfile: 1010,
  ConfigurationChange: 2052,
  DataTransfer: 1020,
  DiagnosticsStatusNotification: 1023,
  DynamicLoadBalancing: 2026,
  EcoChargeScheduleRequest: 2000,
  EcoMode: 2001,
  FaultClear: 2016,
  FaultSet: 2007,
  FirmwareStatusNotification: 1013,
  GatewayLocalConnection: 2023,
  GatewayLocalConnectionStatus: 2024,
  GatewayTokenRefresh: 2025,
  GetCompositeSchedule: 1011,
  GetConfiguration: 1015,
  GetCustomConfigurations: 2019,
  GetDiagnostics: 1022,
  GetEcoMode: 2040,
  GetInventoryReport: 2008,
  GetLgcConfig: 2054,
  GetNetworkStatistics: 2050,
  GetPartnerConnectionStatus: 2047,
  GetPhaseInfo: 2039,
  GetSshConfig: 2036,
  GetVpnStatus: 2022,
  GlobalAuthConfig: 2004,
  GlobalAuthStatus: 2017,
  InstallCertificate: 2030,
  InstallChargePointCertificate: 2031,
  InventoryReport: 2002,
  LgcSlots: 2038,
  LocalIntegrationSafeMode: 2029,
  MeterConfig: 2041,
  MeterConfirmation: 2044,
  MeterConnectionStatus: 2042,
  MeterDetectionStatus: 2043,
  MeterValues: 1006,
  MIDUploadStatus: 2014,
  NetworkConfig: 2003,
  NetworkStatistics: 2049,
  OffGridStatus: 2051,
  PartnerConnectionStatus: 2046,
  PartnerOcppConfig: 2045,
  PhaseInfo: 2005,
  RandomDelayStatus: 2033,
  RemoteStartTransaction: 1007,
  RemoteStopTransaction: 1008,
  Reset: 1017,
  ResetOrientation: 2034,
  ResetPartnerConnection: 2048,
  RetireCharger: 2010,
  SecurityEventNotification: 1024,
  SendLocalList: 1016,
  SetChargingProfile: 1009,
  SetCustomConfigurations: 2018,
  SetSshConfig: 2035,
  SetVpnConfig: 2021,
  SignatureInfo: 2013,
  SkipRandomDelay: 2032,
  StartTransaction: 1004,
  StatusNotification: 1003,
  StopTransaction: 1005,
  TimezoneInfo: 2015,
  TriggerMessage: 1018,
  UnlockConnector: 1026,
  UpdateFirmware: 1012,
  UpdateLgcConfig: 2053,
  WifiRssi: 2006,
};
